// extracted by mini-css-extract-plugin
export default {"backdrop":"TaskForm_backdrop__aUxWA","task-box":"TaskForm_task-box__OtYme"};